import AddUserToWeeklyEmail from '@/services/users/preferencesService/AddUserToWeeklyEmail';
import DoubleOptInConfirmation from '@/services/users/preferencesService/DoubleOptInConfirmation';
import DoubleOptInSpoilerConfirmation from '@/services/users/preferencesService/DoubleOptInSpoilerConfirmation';
import UpdateUserToLilyFree from '@/services/users/preferencesService/UpdateUserToLilyFree';

export default class PreferencesService {
    async addUserToWeeklyEmail(userId) {
        return (new AddUserToWeeklyEmail()).handle(userId);
    }

    async updateUserToLilyFree(userId, subscriptionId) {
        return (new UpdateUserToLilyFree()).handle(userId, subscriptionId);
    }

    async confirmDoubleOptIn(userId) {
        return (new DoubleOptInConfirmation()).handle(userId);
    }

    async confirmDoubleOptInSpoiler(userId) {
        return (new DoubleOptInSpoilerConfirmation()).handle(userId);
    }
}
